import { render, staticRenderFns } from "./TbkcIndex.vue?vue&type=template&id=8d2d871c&scoped=true&"
import script from "./TbkcIndex.vue?vue&type=script&lang=js&"
export * from "./TbkcIndex.vue?vue&type=script&lang=js&"
import style0 from "./TbkcIndex.vue?vue&type=style&index=0&id=8d2d871c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d2d871c",
  null
  
)

export default component.exports